import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { SearchConfigService } from '../search-results/services/search-config.service';
import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class SearchRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {
    private readonly searchEnabled: boolean;

    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router,
        searchConfigService: SearchConfigService
    ) {
        super(router, capabilitiesService);
        this.searchEnabled = capabilitiesService.capabilities.showSearch && !!searchConfigService.config;
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.searchEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.searchEnabled);
    }
}
